<template>
  <div>
    <div class="nv-navbar" id="menu-nv">
      <v-row>
        <v-col
          cols="12"
          xl="10"
          lg="10"
          md="10"
          class="d-flex align-items-center justify-content-between"
        >
          <router-link class="d-none d-sm-block" to="/">
            <img class="logo-store" src="@/assets/store/home/svglogo.svg" alt="">
          </router-link>
          <div class="container-items-menu d-none d-sm-none d-md-block">
            <v-menu
              open-on-hover
              bottom
              offset-y
              rounded="0"
              dark
              class="btn-link"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  NOSOTROS
                </v-btn>
              </template>
              <div class="underline-btn"></div>
              <v-list class="mt-2" dense color="primary">
                <ul class="title">
                  <li>
                    <router-link to="/nuestra-historia">
                      <b>Historia</b>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/colaboraciones">
                      <b>Colaboraciones</b>
                    </router-link>
                  </li>
                </ul>
              </v-list>
            </v-menu>
            <v-menu
              open-on-hover
              bottom
              offset-y
              rounded="0"
              dark
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  dark
                  text
                  v-bind="attrs"
                  v-on="on"
                  class="item-menu"
                  to="/lista/productos/todos/t"
                >
                  PRODUCTOS
                </v-btn>
              </template>
              <div class="underline-btn"></div>
              <v-list class="mt-2" dense color="primary">
                <ul class="title">
                  <li>
                    <router-link to="/lista/productos/todos/t">
                      <b>Todos</b>
                    </router-link>
                  </li>
                  <li v-for="cat of data_home_page.categories_flavors" :key="cat.id">
                    <router-link :to="`/lista/productos/${cat.key_}/${cat.id}`">
                      <b>{{ cat.name }}</b>
                    </router-link>
                  </li>
                </ul>
              </v-list>
            </v-menu>
            <v-menu
              open-on-hover
              bottom
              offset-y
              rounded="0"
              dark
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  CONTACTO
                </v-btn>
              </template>
              <div class="underline-btn"></div>
              <v-list class="mt-2" dense color="primary">
                <ul class="title">
                  <li>
                    <router-link to="/sucursales">
                      <b>Sucursales</b>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/politicas-privacidad">
                      <b>Legal</b>
                    </router-link>
                  </li>
                </ul>
              </v-list>
            </v-menu>
            <campaign-button
              link="/dilo-con-nieve"
              campaign_name="#DiloConNieve"
              v-if="data_home_page.on_dcn"
            />
            <v-btn
              v-if="!user.subscription && data_home_page.enabled_subscriptions"
              color="primary"
              :class="`${activeRoute('Subscriptions') ? 'nv-btn-active' : ''} btn-subscription`"
              dark
              to="/suscripciones"
            >
              MEMBRESÍA
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" xl="2" lg="2" md="2" sm="12" class="container-bolsa-session-navbar">
          <v-menu
            bottom
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="pr-10 ml-sm-3">
                <div style="position: relative;">
                  <span class="font-backward session-name-navbar font-weight-bold">
                    {{ is_auth ? user.name : `¡Hola!` }}
                    <v-icon color="white">mdi-chevron-down</v-icon>
                  </span>
                  <img class="img-session-navbar" src="@/assets/store/home/session_name.png" alt="">
                </div>
              </div>
            </template>

            <v-list color="primary" dense>
              <v-list-item to="/iniciar-sesion" v-if="!is_auth">
                <v-list-item-title>INICIAR SESIÓN</v-list-item-title>
              </v-list-item>
              <v-list-item to="/registro" v-if="!is_auth">
                <v-list-item-title>REGISTRARME</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="is_auth" @click="() => $router.push('/mi-cuenta')">
                <v-list-item-title>MI CUENTA</v-list-item-title>
              </v-list-item>
              <v-list-item :inactive="inactive_item" v-if="is_auth" @click="logout()">
                <v-list-item-title>SALIR</v-list-item-title>
              </v-list-item>
            </v-list>

          </v-menu>

          <div class="d-none d-sm-none d-md-block">
            <v-badge
              class="d-none d-sm-block"
              bordered
              left
              :content="`${quantity_items_cart}`"
              color="accent"
              offset-x="10"
              offset-y="10"
            >
              <img @click="open_cart = true" class="cart-bolsa" src="@/assets/store/iconos/bolsa.svg">
            </v-badge>
          </div>

        </v-col>
      </v-row>
    </div>

    <v-dialog
      v-model="open_cart"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card color="light">
        <v-toolbar
          color="light"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="open_cart = false"
            class="mr-2"
          >
            <v-icon large color="accent">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <Cart @closeModal="open_cart = false" :flavors="data_home_page.flavors"></Cart>

      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import HomeService from '@/services/home.service'
import Cart from '@/components/store/Cart'
import CampaignButton from '@/components/store/CampaignButton'

export default {
  components: {
    Cart,
    CampaignButton
  },
  data: () => ({
    overlay: false,
    inactive_item: false,
    open_cart: false,
    flavors: [],
    drawer: false,
    group: '',
    miniVariant: false
  }),
  computed: {
    ...mapState(['cart', 'is_auth', 'user', 'data_home_page', 'number_day', 'current_month']),
    ...mapGetters(['quantity_items_cart'])
  },
  methods: {
    activeRoute(routeName) {
      if (this.$route.name == routeName) return true
      return false
    },
    openSidebar(val) {
      this.drawer = val
    },
    async logout() {
      try {
        this.overlay = true
        this.inactive_item = true
        await HomeService.logout()
        await this.$store.dispatch('setUser', {
          name: '',
          lastname: '',
          email: '',
          phone: '',
          role: '',
          address: ''
        })

        localStorage.removeItem('token')

        this.$store.dispatch('setSession', false)
        this.$store.dispatch('cleanCart')

        this.inactive_item = false
        if (this.$route.path != '/') {
          this.$router.push('/')
        }
        this.overlay = false
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
  .image-flavor-cart {
    cursor: pointer;
  }
  .table th {
    color: var(--color-tertiary);
    font-family: var(--font-baloo-regular)
  }
  .v-btn {
    height: 25px !important;
    margin-right: 0;
    padding: 0 15px 0 15px !important
  }
  .v-btn::before {
    background-color: white !important;
  }
  .v-list {
    padding: 0 10px !important;
  }
  .v-menu__content {
    box-shadow: none !important;
  }
  ul {
    list-style: none;
    color: #fff;
    font-family: var(--font-baloo-light);
  }
  li {
    line-height: 1.8;
  }
  ul li b {
    font-size: 15px;
    color: #fff
  }
  .title {
    padding-left: 5px !important;
  }
  .subtitle {
    padding-left: 10px !important;
  }
  @media (max-width: 1024px) {
    .v-btn {
      padding: 0 5px 0 5px !important
    }
  }
  @media only screen and (min-width: 1500px) and (max-width: 2000px) {
    ul li b {
      font-size: 15px;
    }
    .v-btn {
      margin-right: 0;
      padding: 0 20px 0 20px !important
    }
  }
  @media only screen and (min-width: 2080px) and (max-width: 3000px) {
    ul li b {
      font-size: 18px;
    }
    .v-btn {
      margin-right: 0;
      padding: 0 20px 0 20px !important
    }
  }
  @media only screen and (min-width: 960px) and (max-width: 1264px) {
    .btn-subscription {
      margin-left: 1%;
    }
    >>>.v-btn {
      font-size: 15px !important;
      padding: 0 10px 0 10px !important
    }
  }
</style>
